import {fromUtcTimeFormat} from "../../../shared/utils/dayjsUtil";

const LOG_TYPE_TEXT = {
    Gain_MiracleBadge: '획득',
    Spend_MiracleBadge: '소모',
    Expire_MiracleBadge: '만료',
};

const getLogTypeText = (logType) => LOG_TYPE_TEXT[logType] || logType;

const parseLogData = (logString, record) => {
    if (!record.parsedLogData) {
        try {
            record.parsedLogData = JSON.parse(logString);
        } catch (error) {
            console.error('logString 파싱 오류:', error);
            record.parsedLogData = {};
        }
    }
    return record.parsedLogData;
};

export const getMiracleBadgeLogColumns = () => {
    return [
        {
            title: '로그 타입',
            dataIndex: 'logString',
            render: (logString, record) => getLogTypeText(parseLogData(logString, record).logType),
            filterMultiple: false,
            filters: [
                {text: '획득', value: 'Gain_MiracleBadge'},
                {text: '소모', value: 'Spend_MiracleBadge'},
                {text: '만료', value: 'Expire_MiracleBadge'},
            ],
            onFilter: (value, record) => parseLogData(record.logString, record).logType === value,
        },
        {
            key: 'badgeGuidSearch',
            title: '뱃지 고유 아이디',
            dataIndex: 'logString',
            search: true,
            render: (logString, record) => parseLogData(logString, record).badgeGuid,
        },
        {
            title: '교환된 뱃지',
            dataIndex: 'logString',
            render: (logString, record) => {
                const {targetBadgeIndex, targetBadgeName} = parseLogData(logString, record);
                return `${targetBadgeName ?? ''}(${targetBadgeIndex ?? ''})`;
            },
        },
        {
            title: '변화량',
            dataIndex: 'logString',
            render: (logString, record) => parseLogData(logString, record).updatedValue,
        },
        {
            title: '보유량',
            dataIndex: 'logString',
            render: (logString, record) => parseLogData(logString, record).lastValue,
        },
        {
            title: '트리거 시간',
            dataIndex: 'logString',
            render: (logString, record) => {
                const {triggerTime} = parseLogData(logString, record);
                return triggerTime ? fromUtcTimeFormat(triggerTime) : '';
            },
        },
        {
            title: '만료 시간',
            dataIndex: 'logString',
            render: (logString, record) => {
                const {expiredTime} = parseLogData(logString, record);
                return expiredTime ? fromUtcTimeFormat(expiredTime) : '';
            },
        },
    ];
};
